import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";

export const patchUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchUserProfile: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: (request) => ({
                url: apiUserLink.user.info,
                method: "PATCH",
                body: request
            }),
            invalidatesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const {usePatchUserProfileMutation} = patchUserProfileApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";

export const patchUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchUserProfile: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: (request) => ({
                url: apiUserLink.user.info,
                method: "PATCH",
                body: request
            }),
            invalidatesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const {usePatchUserProfileMutation} = patchUserProfileApi;
